<template>
  <div :class="`col-auto messages ${isLoading ? 'row justify-center' : ''}`">
    <div
      class="col-auto"
      v-if="isLoading"
    >
      <q-spinner-ios
        v-once
        color="primary"
        size="3em"
      />
    </div>

    <q-virtual-scroll
      v-else
      style="height: 300px; max-height: 300px; width: 100%"
      class="column full-width"
      :items="messages"
    >
      <template #default="{ item }">
        <AttendanceChatMessage
          :msg="item"
        />
      </template>
    </q-virtual-scroll>
  </div>
</template>

<script>
import api from '@/libs/api'
import AttendanceChatMessage from '@/components/AttendanceChatMessage'
import { getMessageStatus } from '@/libs/helpers'

export default {
  props: {
    attendanceId: {}
  },
  components: {
    AttendanceChatMessage
  },

  data () {
    return {
      isLoading: true,
      messages: []
    }
  },

  mounted () {
    const vm = this
    vm.$nextTick().then(() => vm.loadMessages())
  },

  methods: {
    loadMessages () {
      const vm = this

      const queryParams = {
        page: 1,
        limit: 99999,
        byChatId: true
      }

      api.loadChatMessages(vm.attendanceId, queryParams).then(({ messages }) => {
        vm.messages = Array.isArray(messages)
          ? messages.map((msg) => Object.assign({}, msg, getMessageStatus(msg))).reverse()
          : []

        vm.isLoading = false
      })
    }
  }
}

</script>

<style lang="sass">

  .messages
    .q-virtual-scroll__content
      width: 100%
</style>
